import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { IoTicketSharp } from "react-icons/io5";
import { FaCalendarAlt, FaQuora } from "react-icons/fa";
import { SupportTickets } from "../../../../api/Supporttickets";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function HeroSupportTickets({ modalOpen,setModalOpen,priority,setPriority,query,setQuery,handleSubmit,loading,modaltype, ticketStatus, setTicketStatus, itDashboard }) {
 
  const card = {
    height: "165px",
    width: "270px",
    backgroundColor: "white",
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "24px",
    cursor: "pointer",
  };

  return (
    <Container fluid className="px-3">
      {/* Banner */}
      <Row className="justify-content-center">
        <Col xs="12">
          <div
            style={{
              backgroundColor: "#1D67AA",
              borderRadius: "24px",
              padding: "70px 20px 140px",
              textAlign: "center",
            }}
          >
            <h1 style={{ fontSize: 48, color: "#FDFEFF" }}>
              Need our help? We’ve got your back
            </h1>
          </div>
        </Col>
      </Row>

      {/* Cards */}
      <Row
        className="justify-content-center gx-2 gy-3"
        style={{ marginTop: "-100px" }}
      >
        {/* Generate Ticket */}
        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card} onClick={() => setModalOpen(true)}>
            <IoTicketSharp style={{ fontSize: 67, color: "#1D67AA" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>
              Generate Support Ticket
            </h2>
          </div>
        </Col>

        {/* Schedule Meeting */}
        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card}>
            <FaCalendarAlt style={{fontSize: 67, color: "#1D67AA" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>
              Schedule a Meeting
            </h2>
          </div>
        </Col>

        {/* FAQ */}
        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card}>
            <FaQuora style={{ fontSize: 67, color: "#1D67AA" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>FAQ</h2>
          </div>
        </Col>
      </Row>

      {/* Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered>
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          {modaltype == 'add' ? 'Generate' : 'Edit'} Support Ticket
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="priority">Priority</Label>
            <Input
              type="select"
              id="priority"
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            >
              <option value="">-- Select Priority --</option>
              <option value={'high'} >High</option>
              <option value={'medium'} >Medium</option>
              <option value={'low'} >Low</option>
            </Input>
          </FormGroup>
         {modaltype == 'edit' && <FormGroup>
            <Label for="priority">Change Status</Label>
            <Input
              type="select"
              id="priority"
              value={ticketStatus}
              onChange={(e) => setTicketStatus(e.target.value)}
            >
              <option value="">-- Select Status --</option>
               <option value={'open'} >Open</option>
              {/* {itDashboard && <option value={'closed'} >Closed</option>} */}
              <option value={'closed'} >Closed</option>
              <option value={'reopen'} >Reopen</option>
            </Input>
          </FormGroup>}
          <FormGroup>
            <Label for="query">Your Query</Label>
            <Input
              type="textarea"
              id="query"
              rows="4"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Describe your issue..."
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? "Submitting..." : modaltype == 'add' ? "Submit" : 'Update'}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}
